export default class OptimizationGroup {
	constructor({
		id,
		name,
		description,
		company_id,
		added_on,
		update_on,
		total_optimization,
		total_created,
		total_processing,
		total_finalized,
		total_error,
	}) {
		this.id = id || 0;
		this.name = name || "";
		this.description = description || "";
		this.company_id = company_id || 0;
		this.added_on = added_on || "";
		this.update_on = update_on || "";
		this.total_optimization = total_optimization || 0;
		this.total_created = total_created || 0;
		this.total_processing = total_processing || 0;
		this.total_finalized = total_finalized || 0;
		this.total_error = total_error || 0;
	}
}
